var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReasonCodeSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 55,
    viewBox: "0 0 74 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3121_7988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3599 7.70592H53.7499V27.6859H27.3599C27.3599 27.6859 27.5799 8.01592 27.3599 7.71592V7.70592Z",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1601 1.71592H57.0401C58.1201 1.71592 59.0001 2.59592 59.0001 3.67592V38.7159C59.0001 39.7959 58.1201 40.6759 57.0401 40.6759H24.0801C22.9901 40.6759 22.1201 39.8059 22.1201 38.7159C22.1701 32.0659 22.3201 10.3859 22.2001 3.69592C22.1801 2.60592 23.0601 1.71592 24.1601 1.71592V1.71592Z",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3999 31.9559V35.4959",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3799 31.9559V35.4959",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9897 5.04592H71.8697C72.6197 5.04592 73.2297 5.65592 73.2297 6.40592V37.0659C73.2297 37.8159 72.6197 38.4259 71.8697 38.4259H58.9897",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1 5.04592H2.81002C1.69002 5.04592 0.77002 5.65592 0.77002 6.40592V37.0659C0.77002 37.8159 1.68002 38.4259 2.81002 38.4259H22.1",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5497 8.59592H4.98975V12.9259H17.5497V8.59592Z",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83998 19.3859C8.86723 19.3859 9.69998 18.5532 9.69998 17.5259C9.69998 16.4987 8.86723 15.6659 7.83998 15.6659C6.81273 15.6659 5.97998 16.4987 5.97998 17.5259C5.97998 18.5532 6.81273 19.3859 7.83998 19.3859Z",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9298 19.3859C15.9571 19.3859 16.7898 18.5532 16.7898 17.5259C16.7898 16.4987 15.9571 15.6659 14.9298 15.6659C13.9026 15.6659 13.0698 16.4987 13.0698 17.5259C13.0698 18.5532 13.9026 19.3859 14.9298 19.3859Z",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83998 26.1659C8.86723 26.1659 9.69998 25.3332 9.69998 24.3059C9.69998 23.2787 8.86723 22.4459 7.83998 22.4459C6.81273 22.4459 5.97998 23.2787 5.97998 24.3059C5.97998 25.3332 6.81273 26.1659 7.83998 26.1659Z",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9298 26.1659C15.9571 26.1659 16.7898 25.3332 16.7898 24.3059C16.7898 23.2787 15.9571 22.4459 14.9298 22.4459C13.9026 22.4459 13.0698 23.2787 13.0698 24.3059C13.0698 25.3332 13.9026 26.1659 14.9298 26.1659Z",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51973 35.7759C8.06612 35.7759 9.31973 34.5223 9.31973 32.9759C9.31973 31.4295 8.06612 30.1759 6.51973 30.1759C4.97333 30.1759 3.71973 31.4295 3.71973 32.9759C3.71973 34.5223 4.97333 35.7759 6.51973 35.7759Z",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9797 35.7759C16.5261 35.7759 17.7797 34.5223 17.7797 32.9759C17.7797 31.4295 16.5261 30.1759 14.9797 30.1759C13.4333 30.1759 12.1797 31.4295 12.1797 32.9759C12.1797 34.5223 13.4333 35.7759 14.9797 35.7759Z",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3799 30.4259L18.6499 29.2159L17.4399 31.4859L16.3799 30.4259Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31006 30.4259L9.57006 29.2159L8.37006 31.4859L7.31006 30.4259Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6597 10.7659H69.5897",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6597 13.5959H69.5897",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6597 16.4259H69.5897",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5899 38.8059V52.4859C69.5899 53.2759 68.9499 53.9159 68.1599 53.9159H56.1099L53.7399 49.8259H26.6899L23.6099 53.9159H4.05988C3.26988 53.9159 2.62988 53.2759 2.62988 52.4859V38.5059",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92969 42.9559H18.1197",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92969 46.2659H18.1197",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92969 49.5859H18.1197",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.29 18.4259V24.9759",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0098 20.8659V24.9759",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7397 16.4259V24.9759",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4697 19.4359V24.9759",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1899 17.5259V24.9759",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9199 15.6659V24.9759",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9399 15.1059C29.9399 15.1059 34.2699 17.5259 35.3499 17.5259C35.8899 17.5259 36.3499 17.2559 37.5099 14.6059C38.6699 11.9559 40.9199 14.4459 42.0899 15.6159C43.2599 16.7859 43.6699 16.7559 46.5899 14.6059C49.4999 12.4559 51.3799 12.5959 51.3799 12.5959",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3121_7988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.2,
    height: 53.32,
    fill: "white",
    transform: "translate(0.399902 0.965916)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReasonCodeSelection);
export default __webpack_public_path__ + "static/media/reason-code-selection.6ac50d4cebf4b1927392247c7d938487.svg";
export { ForwardRef as ReactComponent };